export const styles = (theme) => ({
  root: {
    textTransform: 'uppercase',
    ...theme.typography.h9,
    minWidth: 'auto',
  },
  iconRoot: ({ buttonProps: { disabled } }) => ({
    ...theme.typography.h9,
    minWidth: 'auto',
    '& img': {
      filter: disabled ? 'grayscale(100%) brightness(1.2)' : 'none',
      position: 'relative',
      top: -2,
    },
  }),
  startIcon: ({ buttonProps: { disabled } }) => ({
    marginRight: 6,
    '& > span': {
      width: 21,
      height: 20,
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
    },
    '& img': {
      filter: disabled ? 'grayscale(100%) brightness(1.2)' : 'none',
    },
  }),
});
